const posts = [
  {
    id: 1,
    title: 'Cancún: el viaje que superó todas mis expectativas',
    description:
      'Playas de agua turquesa, excelente hotel y organización impecable. Cancún no es solo fiesta, es descanso, lujo y recuerdos que se quedan para siempre.',
    imageUrl: '/Blog/Cancun.jfif',
    date: 'Ene 22, 2025',
    author: { name: 'Andrea López', initial: 'A' },
  },
  {
    id: 2,
    title: 'República Dominicana: sol, sabor y pura felicidad',
    description:
      'La calidez de su gente, las playas infinitas y el ritmo caribeño hacen que quieras quedarte. Ideal para desconectarse y disfrutar sin preocupaciones.',
    imageUrl: '/Blog/RepublicaDominicana.jfif',
    date: 'Feb 5, 2025',
    author: { name: 'Carlos Méndez', initial: 'C' },
  },
  {
    id: 3,
    title: 'Colombia: colores, cultura y momentos inolvidables',
    description:
      'Colombia sorprende en todo sentido. La comida, la historia, la música y cada rincón lleno de vida. Un destino que te deja con ganas de volver.',
    imageUrl: '/Blog/Colombia.jfif',
    date: 'Mar 1, 2025',
    author: { name: 'María Fernanda Ruiz', initial: 'M' },
  },
]

export default function Blog() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        <div className="mx-auto max-w-2xl text-center mb-14">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{ color: '#F5A020' }}>
            Opiniones reales
          </p>
          <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
            Historias de viajeros felices
          </h2>
          <p className="mt-4 text-base text-gray-500">
            Personas reales que viajaron con Despega GT y vivieron momentos inolvidables.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="flex flex-col rounded-2xl overflow-hidden border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  alt={post.title}
                  src={post.imageUrl}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                {/* Estrellas */}
                <div className="absolute bottom-3 left-4 flex gap-0.5">
                  {[1,2,3,4,5].map(s => (
                    <svg key={s} className="w-3.5 h-3.5" fill="#F5A020" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>

              <div className="flex flex-col flex-1 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs flex-shrink-0"
                    style={{ background: '#2E38A4' }}
                  >
                    {post.author.initial}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-800">{post.author.name}</p>
                    <p className="text-xs text-gray-400">{post.date}</p>
                  </div>
                </div>

                <h3 className="text-sm font-bold text-gray-900 leading-snug mb-3">
                  {post.title}
                </h3>

                <p className="text-sm text-gray-500 leading-relaxed flex-1">
                  {post.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-sm text-gray-400 mb-5">¿Listo para crear tu propia historia?</p>
          <a
            href={`https://wa.me/50239990332?text=${encodeURIComponent('Hola, quiero planificar mi viaje con Despega GT')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 rounded-xl font-bold text-white text-base shadow transition hover:opacity-90"
            style={{ background: '#F5A020' }}
          >
            Empieza tu aventura
          </a>
        </div>
      </div>
    </div>
  )
}
